import * as R from '../../../routes';
import { getAdminRouteForNavigation } from '../../../routes-pairs';
import { getAngularServiceWeak } from '../AngularService';
import { getCurrentUser } from '../CurrentUser';
import { redirect } from '../Router';

function redirectToApp(url: string, params?: { [key: string]: string }, forceReload?: boolean) {
    redirect(`/app${url}`, params, forceReload);
}

export function goToReviewCycleOverview(cycleId: string): void {
    getAngularServiceWeak('ReviewCycleLookupService')?.reset();
    redirectToApp(getAdminRouteForNavigation(R.YOUR_COMPANY_REVIEWS_WITH_CYCLE), { cycleId });
}

export function goToReviewCycleManagement(): void {
    redirectToApp(getAdminRouteForNavigation(R.YOUR_COMPANY_REVIEWS_SELECT_CYCLE));
}

export function goToFeedbackCycleOverview(cycleId: string): void {
    getAngularServiceWeak('FeedbackCycleLookupService')?.reset();
    redirectToApp(getAdminRouteForNavigation(R.YOUR_COMPANY_FEEDBACK_WITH_CYCLE), { cycleId });
}

export function goToFeedbackCycleManagement(): void {
    redirectToApp(getAdminRouteForNavigation(R.YOUR_COMPANY_FEEDBACK_SELECT_CYCLE));
}

export function goToObjectiveCycleOverview(cycleId: string): void {
    getAngularServiceWeak('ObjectiveCycleLookupService')?.reset();
    redirectToApp(R.YOUR_COMPANY_OBJECTIVES_OVERVIEW, { cycleId });
}

export function goToObjectiveCycleManagement(): void {
    redirectToApp(getAdminRouteForNavigation(R.YOUR_COMPANY_OBJECTIVES_SELECT_CYCLE));
}

export function goToFeedbackPage(): void {
    redirectToApp(R.FEEDBACK_USER);
}

export function goToMeetingDedicatedPage(meetingId: string): void {
    redirectToApp(R.MEETING_DEDICATED, { meetingId });
}

export function goToMeetingPage(participantId: string, forceReload: boolean): void {
    redirectToApp(R.MEETING_PAGE, { userIds: `${getCurrentUser().id}${participantId}` }, forceReload);
}

export function goToMeetingOverviewPage(): void {
    redirectToApp(R.MEETING_OVERVIEW);
}

export function goToDashboardPage() {
    redirectToApp(R.DASHBOARD);
}

export function goToOnboardingSurveyOriginStep() {
    redirectToApp(R.COMPANY_ONBOARDING_ORIGIN);
}

export function goToOnboardingSurveyInterestStep() {
    redirectToApp(R.COMPANY_ONBOARDING_INTEREST);
}

export function goToOnboardingSurveyHris() {
    redirectToApp(R.COMPANY_ONBOARDING_HRIS);
}

export function goToOnboardingSurveyDone() {
    redirectToApp(R.COMPANY_ONBOARDING_DONE);
}

export function goToCheckout() {
    redirectToApp(R.ADMIN_BILLING_CHECKOUT);
}
